import { Inject, Component, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { AccountAPIService } from '../account-api.service';
import { AppSettingService, AppUtilityService } from '../../app.service';
import { UserInfoService, IUserProfile, IUserOtherAccount } from '../user-info.service';
import { SessionAPIService } from '../user-api.service';
import { SignupLoginService } from '../signupLogin/signup-login.component';


@Component({
	selector: "app-switch-account",
	templateUrl: "./switch-account.component.html",
	styleUrls: ['../../navigation/navigation.component.scss'],
	standalone: false
})
export class SwitchAccountComponent {
	@Input() currentZone: string = "true|false";
	private accountMonitor: Subscription;
	canSwitch: boolean = false;
	user: IUserProfile = null;
	previousUserId: string = "";
	mobileView: boolean = AppSettingService.widgetMobile();
	oAccounts: {
		Zone: string,
		Accounts: IUserOtherAccount[]
	}[] = [];

	constructor(
		private dialog: MatDialog,
		private signupLoginSrv: SignupLoginService,
		private userInfo: UserInfoService
	) { }

	@HostListener('window:resize', ['$event']) onResize(e: any) {
		this.mobileView = AppSettingService.widgetMobile();
	}

	private myPopup: any = null;
	changeAccount(personId: string) {
		this.myPopup = this.dialog.open(
			SwitchAccountDialog,
			{
				disableClose: true,
				panelClass: 'jmDialogNoScroll',
				width: "400px",
				height: "400px",
				data: {
					personId: personId
				}
			}
		);
		this.myPopup.afterClosed().subscribe({
			next: (result: any) => {
				if (result !== "") {
					Swal.fire({ title: "", text: result, icon: "error" });
				}
			}
		});
	}

	ngOnDestroy() {
		if (this.accountMonitor) {
			this.accountMonitor.unsubscribe();
		}
		if (this.myPopup != null) {
			this.myPopup.close();
		}
	}

	ngAfterViewInit(): void {
	}

	ngOnInit(): void {
		this.accountMonitor = this.userInfo.UserInfoTimestamp.subscribe({
			next: () => {
				this.user = this.userInfo.getProfile();
				this.canSwitch = false;
				if (!this.userInfo.isAnonymous()) {
					if (this.user.OtherAccounts != null && this.user.OtherAccounts.length > 0) {
						this.canSwitch = true;
						this.oAccounts = [];
						this.user.OtherAccounts.forEach(
							(a) => {
								let o = this.oAccounts.find((x: any) => x.Zone === a.Zone);
								if (o) {
									o.Accounts.push(a);
								}
								else {
									let n: any = { Zone: a.Zone, Accounts: [] };
									n.Accounts.push(a);
									this.oAccounts.push(n);
								}
							}
						);
					}
					else {
						this.oAccounts = [];
					}
				}

			},
			error: (error: any) => {
				console.log(error);
				this.oAccounts = [];
				this.user = null;

				this.canSwitch = false;
			}
		});
	}
}


@Component({
	template: `
<div class="w-100 h-100 d-flex justify-content-center align-items-center">
	<span style="font-size:18px; margin-right: 10px;">Switching Accunt</span>
	<span class="jmWidgetLoadingIcon40"></span>
</div>`,
	standalone: false
})
export class SwitchAccountDialog {
	private personId: string;

	constructor(
		private accountAPI: AccountAPIService,
		private dialogRef: MatDialogRef<SwitchAccountDialog>,
		@Inject(MAT_DIALOG_DATA) private data: any,
		private router: Router,
		private sessionAPI: SessionAPIService,
		private userInfo: UserInfoService
	) {
		this.personId = data.personId
	}

	close(): void {
		
	}

	ngOnInit(): void {
		// do not clean up the session data for the existing account unless we are able to switch
		this.sessionAPI.signOnAsOther(this.personId).subscribe({
			next: () => {
				this.userInfo.clearStorage();
				// delay to get cookie populated
				setTimeout(() => {
					if (!this.userInfo.isJAZone() && this.userInfo.getProfile().HighestRole.toLowerCase() === 'student' || this.userInfo.getProfile().HighestRole.toLowerCase() === 'other') {
						window.location.href = AppSettingService.baseUrl + "/User/CheckMyProgress?tm=" + AppUtilityService.newId();
					}
					else {
						window.location.href = this.userInfo.getHomePage() + ((this.userInfo.getHomePage().indexOf("?") > 0) ? "&" : "?") + "tm=" + AppUtilityService.newId();
					}
					this.dialogRef.close("");
				}, 500);
			},
			error: (err: any) => {
				console.log(err);
				this.dialogRef.close("Unable to switch account. Please retry later.");
			}
		});
	}
}
